export default "__VITE_ASSET__BnrYBW_S__"